import { Progress, Table, TableColumn } from "@backstage/core-components";
import { Spacer } from "@internal/plugin-utilities";
import { Typography } from "@material-ui/core";
import React from "react";
import { InformationTooltip } from "../InformationTooltip";
import { SectionHeader } from "../TeamBreakdown/SectionHeader/SectionHeader";
import { TeamSelect } from "./TeamSelect";

interface Props {
  data: any;
  loading: boolean;
}

export const OwnershipSection: React.FC<Props> = ({
  data,
  loading,
}): JSX.Element => {
  if (loading) {
    return <Progress />;
  }

  const tooltip = (
    <>
      <Typography variant="h5">Incidents</Typography>
      <div>
        This section is intended to find rightful owners of the company
        repositories, or allow us to archive ones that are defunct. Any repo
        missing a <code>catalog-info.yaml</code> document, that has not had an
        owner specified, will be added to this list.
      </div>
    </>
  );

  if (data) {
    const columns: TableColumn<any>[] = [
      {
        title: "Repo",
        field: "repo",
        render: (rowData) => {
          return (
            <a href={rowData.link} target="_blank">
              {rowData.repo}
            </a>
          );
        },
      },
      {
        title: "Team",
        field: "team",
        render: (rowData) => {
          return <TeamSelect repo={rowData.repo} link={rowData.link} />;
        },
      },
    ];

    let jsx: JSX.Element = (
      <Typography variant="h5">
        🎉 All relevant repos have ownership defined! 🎉
      </Typography>
    );

    if (data.length > 0) {
      jsx = (
        <Table
          options={{
            sorting: false,
            search: true,
            paging: true,
            pageSize: 5,
            padding: "dense",
          }}
          columns={columns}
          data={data}
        />
      );
    }

    return (
      <div style={{ textAlign: "center" }}>
        <SectionHeader vendor="kajabi" title="Ownership" />
        <InformationTooltip title={tooltip} />
        <Spacer variant="normal" />
        {jsx}
      </div>
    );
  }

  return (
    <div>
      <SectionHeader vendor="kajabi" title="Ownership" />
      <InformationTooltip title={tooltip} />
      <Spacer variant="normal" />
      <Progress />
    </div>
  );
};
